import Spinner from 'components/Common/Spinner';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useBusiness } from 'providers/context/BusinessProvider';
import { completeLoginSession, decodeNetsapiensSession } from 'apis/auth/completeLoginSession';
import * as urls from 'routes/config';

export default function NetsapiensCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setSelectedBusiness, setSelectedLocation } = useBusiness();

  useEffect(() => {
    const session = searchParams.get('session');

    if (!session) {
      navigate(`${urls.auth.base}/${urls.auth.login}`, { replace: true });
      return;
    }

    try {
      completeLoginSession(decodeNetsapiensSession(session), {
        navigate,
        setSelectedBusiness,
        setSelectedLocation
      });
    } catch {
      navigate(`${urls.auth.base}/${urls.auth.login}`, { replace: true });
    }
  }, [navigate, searchParams, setSelectedBusiness, setSelectedLocation]);

  return <Spinner />;
}
